import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Box from '@mui/material/Box';
import { truncate } from 'lodash-es';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { StyledMenuItem, StyledDragHandlerBarArea } from './DraggableList.styles.js';
import IconButton from '../../Button/IconButton.js';
const _excluded = ["item", "index", "children", "onShowOrHide"];
function DraggableListItem(_ref) {
  let {
      item,
      index,
      children,
      onShowOrHide
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const handleHide = event => {
    event.stopPropagation();
    onShowOrHide(_objectSpread2(_objectSpread2({}, item), {}, {
      show: false
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, item.fixed ? /*#__PURE__*/React.createElement(StyledMenuItem, _extends({}, otherProps, {
    className: "shown-item",
    isFixed: item.fixed
  }), /*#__PURE__*/React.createElement(StyledDragHandlerBarArea, null), item.title, ' ') : /*#__PURE__*/React.createElement(Draggable, {
    draggableId: item.id,
    index: index
  }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", _extends({
    ref: provided.innerRef
  }, provided.draggableProps), /*#__PURE__*/React.createElement(StyledMenuItem, _extends({}, otherProps, {
    isFixed: item.fixed
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(StyledDragHandlerBarArea, null, /*#__PURE__*/React.createElement("i", _extends({}, provided.dragHandleProps, {
    className: "meta-crm-icon-ic_columns font-size-16"
  }))), truncate(item.title, {
    length: 20
  })), /*#__PURE__*/React.createElement(IconButton, {
    onClick: event => handleHide(event),
    disabled: item.fixed,
    className: "list-item-btn",
    size: 14
  }, /*#__PURE__*/React.createElement("i", {
    className: "meta-crm-icon-ic_visibilityOff font-size-14"
  }))))));
}
DraggableListItem.propTypes = {
  item: PropTypes.shape({
    fixed: PropTypes.bool,
    title: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node,
  onShowOrHide: PropTypes.func
};
DraggableListItem.defaultProps = {
  children: null,
  onShowOrHide: null
};
export { DraggableListItem as default };